<template>
  <div class="settlement-settings">
    <div class="mb-20">
      <span class="fs-20 fs-b f-c-b ">结算方式 </span><span class="pointer f-c-blue ml-20" @click="showHelper = true"> 结算方式说明<a-icon class="ml-10" type="question-circle" /></span>
    </div>
    <a-table :columns="columns" bordered :row-key="getKey" :data-source="usableList" :pagination="false">

      <div slot="shippername" slot-scope="row" class="flex a-center">
        <img class="w-16 mr-5" :src="icoMap[row.shippercode]" alt="">
        {{ row.shippername }}
      </div>
      <span slot="status" slot-scope="row">
        <a-badge v-if="+row.status === 1" color="green" />{{ status[row.status] }}
      </span>
      <div slot="support" slot-scope="row">
        <div v-if="row.enablemonth">自有月结结算</div>
        <div v-if="row.enableselfsettle">线下自行结算</div>
        <div v-if="row.enableprepayment">公司预存统结</div>
      </div>

      <div slot="serviceDesc" slot-scope="row" class="w-300">
        {{ row.prepaymentdesc||'-' }}
      </div>
      <!-- <div slot="enablemonth" slot-scope="row">
        <div>
          {{ row.monthstatus ? status[row.enablemonth]:'-' }}
        </div>
        <div v-if="row.monthstatus">
          {{ row.monthcode }}
        </div>
      </div>
      <span slot="enableselfsettle" slot-scope="row">
        {{ row.selfsettlestatus ?status[row.enableselfsettle] :'-' }}
      </span> -->
      <a-button slot="action" slot-scope="row" type="primary" @click="showSettingDialog(row)">设置</a-button>
    </a-table>
    <a-modal
      :width="960"
      title="结算方式说明"
      :visible="showHelper"
      @cancel="showHelper = false"
    >
      <div>
        <div class="t-center fs-24 fs-b">
          <div>设置常用快递公司时，可同时设定运费结算方式</div>
          <div>目前支持以下3种</div>
        </div>
        <div>
          <img class="w-100p" src="/assets/manager/helper@2x.png" alt="">
        </div>
        <div class="mt-20">
          <p>
            ① 公司预存统结：适用于还没有签定月结的企业，寄件时本系统从预存运费中实时扣费，可享受优惠价格与运营活动
          </p>
          <p>
            ② 自有月结结算：适用于原先已签定了月结协议的企业，启用时要填写正确的月结编号，下单时仅通知快递员揽件但不参与运费结算
          </p>
          <p>
            ③ 线下自行结算：适用于个人寄件或没有预存的企业，本系统不参与运费结算，由寄件人自行与上门快递员结算
          </p>
        </div>

      </div>
      <div slot="footer">
        <a-button type="primary" @click="setOK">好的，我知道了</a-button>
      </div>
    </a-modal>

    <a-modal
      title="快递公司设置"
      :width="600"
      :footer="null"
      :visible="showSetting"
      @cancel="showSetting = false"
    >
      <a-row>
        <a-col :span="6" class="t-right">快递公司：</a-col>
        <a-col :span="18">{{ form.shippername }}</a-col>
      </a-row>
      <a-row class="mt-10" type="flex" align="middle">
        <a-col :span="6" class="t-right">是否开启使用：</a-col>
        <a-col :span="18">
          <a-select v-model="form.status" class="w-120">
            <a-select-option :value="0">
              关闭
            </a-select-option>
            <a-select-option :value="1">
              启用
            </a-select-option>
          </a-select></a-col>
      </a-row>
      <a-row class="mt-10">
        <a-col :span="6" class="t-right">选择结算方式：</a-col>
        <a-col :span="18">
          <div v-if="form.prepaymentstatus" class="flex a-center border pd-10 mt-10">
            <div>
              <a-checkbox v-model="form.enableprepayment" class="fs-b">预付款在线支付</a-checkbox>
            </div>
            <div>
              <div class="fs-12">预付款余额 {{ form.balance||0 }}元</div>
            </div>
          </div>
          <div v-if="form.monthstatus" class="flex a-center border pd-10 mt-10">
            <div class="pb-30">
              <a-checkbox v-model="form.enablemonth" class="fs-b">自有月结结算</a-checkbox>
            </div>
            <div>
              <div>
                <a-input v-model="form.monthcode" placeholder="请填写月结账号或者编号" />
              </div>
              <div class="f-c-red mt-10 fs-12">
                *填写错误的话将会导致下单失败
              </div>
            </div>

          </div>
          <div v-if="form.selfsettlestatus" class="flex a-center border pd-10 mt-10">
            <a-checkbox v-model="form.enableselfsettle" class="fs-b">线下自行结算</a-checkbox>
          </div>
        </a-col>
      </a-row>
      <a-row class="mt-20 mb-20">
        <a-col :offset="6">
          <a-button
            type="primary"
            @click="postForm"
          >
            保存设置
          </a-button>
          <a-button
            @click="showSetting = false"
          >
            取 消
          </a-button>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>

/**
 * 如何使用vue
 * 这里做最基本的用法演示，详细请看vue的官网
 * https://cn.vuejs.org/v2/guide/
 */
const columns = [
  { title: '快递公司', key: 'shippername', scopedSlots: { customRender: 'shippername' }},
  { title: '服务说明', key: 'serviceDesc', scopedSlots: { customRender: 'serviceDesc' }},
  { title: '预计时效', key: 'estimate', dataIndex: 'estimate' },

  { title: '支持结算方式', key: 'support', scopedSlots: { customRender: 'support' }},
  // { title: '自有月结结算', key: 'enablemonth', scopedSlots: { customRender: 'enablemonth' }},
  // { title: '线下结算', scopedSlots: { customRender: 'enableselfsettle' }, key: 'enableselfsettle' },
  { title: '可用状态', key: 'status', scopedSlots: { customRender: 'status' }},
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }}
]
import icoMap from '@/common/icoMap'

export default {
  name: 'SettlementSettings',
  data() {
    // data函数返回的对象是具有双向绑定的数据，更新data里面的数据，可以触发ui的变化
    return {
      icoMap,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      showHelper: false,
      showSetting: false,
      columns,
      test: 0,

      rules: [],
      form: {
        balance: 0,
        'enablemonth': false,
        'enableprepayment': false,
        selfsettlestatus: false,
        monthstatus: false,
        prepaymentstatus: false,
        'enableselfsettle': false,
        'id': '',
        'monthcode': '',
        'shippercode': '',
        'shippername': '',
        'status': false
      },
      status: {
        0: '未开启',
        1: '已开启'
      },
      articleList: [
      ],
      usableList: null
    }
  },
  async created() {
    // 组件创建时，这个函数就会被触发
    this.getList()
    if (!localStorage.getItem('settlement-settings-hepler')) {
      this.showHelper = true
    }
  },
  methods: {
    async getList() {
      const res = await this.$http(this.$api.logisticsGetUsableList)
      this.usableList = res
    },
    showSettingDialog(row) {
      // Object.keys(this.form).forEach(el=>{
      //   this.form =
      // })
      const form = {
        'enablemonth': !!row.enablemonth,
        'enableprepayment': !!row.enableprepayment,
        selfsettlestatus: !!row.selfsettlestatus,
        monthstatus: !!row.monthstatus,
        prepaymentstatus: !!row.prepaymentstatus,
        'enableselfsettle': !!row.enableselfsettle,
        'id': row.id,
        'monthcode': row.monthcode,
        'shippercode': row.shippercode,
        'shippername': row.shippername,
        'status': row.status
      }
      Object.assign(this.form, form)
      this.showSetting = true
    },
    setOK() {
      localStorage.setItem('settlement-settings-hepler', true)
      this.showHelper = false
    },
    getKey(row) {
      return row.id
    },
    async postForm() {
      const res = await this.$http({ ...this.$api.logisticsSetExpress, origin: true }, {
        'enablemonth': +this.form.enablemonth,
        'enableprepayment': +this.form.enableprepayment,
        selfsettlestatus: +this.form.selfsettlestatus,
        monthstatus: +this.form.monthstatus,
        prepaymentstatus: +this.form.prepaymentstatus,
        'enableselfsettle': +this.form.enableselfsettle,
        'id': this.form.id,
        'monthcode': this.form.monthcode,
        'shippercode': this.form.shippercode,
        'shippername': this.form.shippername,
        'status': this.form.status
      })
      if (res.data.state === 'success' && +this.form.status === 1) {
        this.$success({
          title: '操作说明',
          type: 'success',
          content: h => <div><div >设置成功</div><div>您在“在线寄件”中可选择 {this.form.shippername} 下单</div></div>,
          onOk: () => {
            this.showSetting = false
            this.getList()
          },
          onCancel() {}
        })
      } else {
        this.$success({
          title: '操作说明',
          type: 'success',
          content: h => <div><div >设置成功</div></div>,
          onOk: () => {
            this.showSetting = false
            this.getList()
          },
          onCancel() {}
        })
      }
    }
  }
}
</script>

<style lang="scss" >
 .border{
    border: 1px solid #ddd;
  }
.settlement-settings {

}
</style>
